import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {CreateDeliveryPointData} from "@app/core/delivery-point/application/dtos/create-delivery-point-data";
import {Credentials} from "@app/core/credentials/domain/credentials";
import {DeliveryPointType} from "@app/core/delivery-point/application/dtos/delivery-point-type";

@Injectable({
    providedIn: "root"
})
export abstract class DeliveryPointRemote {
    public abstract getDeliveryPoints(credentials?: Credentials): Observable<DeliveryPoint[]>

    /**
     * Get postal code from coordinates
     * @param latitude
     * @param longitude
     */
    public abstract getPostalCodeFromCoordinates(latitude: number, longitude: number): Observable<string>

    public abstract deleteDeliveryPoint(deliveryPointCode: number): Observable<void>;

    public abstract createDeliveryPoint(createDeliveryPointData: CreateDeliveryPointData, temporalCredentials?: Credentials): Observable<DeliveryPoint>;

    public abstract saveDeliveryPoint(deliveryPointCode: number, credentials?: Credentials): Observable<void>;

    public abstract getDeliveryPointType(deliveryPointCode: number): Observable<DeliveryPointType>;

    public abstract getDeliveryPoint(deliveryPointCode: number): Observable<DeliveryPoint>;
}
